<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-10 mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row mt-2">
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Status</label>
                            <select class="form-control" v-model="advanced_search_input.status">
                                <option value="" selected>Todos os status, exceto canceladas</option>
                                <option value="Processando">Processando</option>
                                <option value="Pendente">Pendente</option>
                                <option value="Paga">Paga</option>
                                <option value="Cancelada">Cancelada</option>
                                <option value="chargedback">Chargedback</option>
                                <option value="Erro">Erro</option>
                                <option value="Em atraso">Em atraso</option>
                                <option value="Falha">Falha</option>
                            </select>
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Vencimento a partir de</label>
                            <input type="date" id="from" class="form-control"
                                v-model="advanced_search_input.due_date_from">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Vencimento até</label>
                            <input type="date" id="to" class="form-control" v-model="advanced_search_input.due_date_to">
                        </div>

                    </div>
                    <div class="row mt-2">

                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card card-table shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Meus pagamentos <small><span
                                    v-if="total_itens > 0">| Total registros encontrados: {{ formatDecimal(total_itens)
                                    }}</span></small><br>
                        </h6>
                        <button class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i>
                            Recarregar dados</button>
                    </div>
                    <div class="card-body" :class="receivable_accounts.length <=0? 'card-body-no-spaccing':''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Cliente / Documento</th>
                                        <th>Descrição</th>
                                        <th>Vencimento</th>
                                        <th class="text-center">Situação</th>
                                        <th class="text-center">Total</th>
                                        <th class="text-center">Descontos(%)</th>
                                        <th class="text-center">Multa</th>
                                        <th class="text-center">Juros(%)</th>
                                        <th class="text-center">Total a pagar</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(receivable_account) in receivable_accounts"
                                        :key="receivable_account.id">
                                        <td class="align-middle">
                                            {{ receivable_account.client.name }}<br>
                                            {{ receivable_account.client.document_formatted }}
                                        </td>
                                        <td class="align-middle">
                                            <span v-if="receivable_account.recurrence != ''"
                                                :tooltip="receivable_account.recurrence.total_installment > 0 ? 'Cobrança parcelada: ' + receivable_account.recurrence.generated_installments + ' / ' + receivable_account.recurrence.total_installment : 'Cobrança recorrente: ' + receivable_account.recurrence.generated_installments + 'ª Parcela'"><i
                                                    class="fa fa-undo"
                                                    v-if="receivable_account.recurrence != ''"></i></span> {{
                                                        receivable_account.description
                                                    }} <button type="button" class="btn btn-link"
                                                v-if="receivable_account.original != '' && receivable_account.receipt != ''"
                                                @click="downloadFile(receivable_account.receipt.id)">(Comprovante)</button><br>
                                            <span class="badge badge-warning"><span
                                                    tooltip="Método de pagamento">{{ receivable_account.method
                                                    }}</span></span>
                                        </td>
                                        <td class="align-middle">{{ receivable_account.due_date_formatted }} </td>
                                        <td class="align-middle text-center">
                                            <span class="badge " :class="badgeStatus(receivable_account.status)">{{
                                                receivable_account.status
                                                }}</span>
                                            <br v-if="receivable_account.status == 'Paga'"><span
                                                v-if="receivable_account.status == 'Paga'" class="badge badge-secondary"
                                                tooltip="Data pagamento">
                                                {{ receivable_account.payment_date_formatted }}
                                            </span>
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.amount_formatted }}
                                            <br v-if="receivable_account.original != ''"><span
                                                class="badge badge-secondary" v-if="receivable_account.original != ''"
                                                tooltip="Valor original">{{
                                                    receivable_account.original.total_receiver_formatted }}</span>
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.discount_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.fine_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.interest_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{
                                            receivable_account.total_receiver_formatted }} </td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"
                                                    :disabled="(receivable_account.status == 'Cancelada' && receivable_account.recurrence == '') || (receivable_account.status == 'Paga' && receivable_account.recurrence == '')">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'ticket_pix' && (receivable_account.status == 'Pendente' || receivable_account.status == 'Em atraso')"
                                                        @click="viewTicketPix(receivable_account.id)">Ver
                                                        boleto</button>
                                                     <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'ticket' || receivable_account.payment.type == 'ticket_pix' && (receivable_account.status == 'Pendente' || receivable_account.status == 'Em atraso')"
                                                        @click="copyDigitableLine(receivable_account.payment)">Copiar
                                                        linha digitável</button>
                                                    <button class="dropdown-item"
                                                        v-if="(receivable_account.payment.type == 'pix' || receivable_account.payment.type == 'ticket_pix') && receivable_account.status == 'Pendente'"
                                                        @click="copyKeyCopyPaste(receivable_account.payment)">Copiar
                                                        chave Copia e Cola</button>
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'ticket' && receivable_account.status == 'Pendente'"
                                                        @click="viewTicket(receivable_account.id)">Ver
                                                        boleto</button>
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'ticket' && receivable_account.status == 'Pendente'"
                                                        @click="copyDigitableLine(receivable_account.payment)">Copiar
                                                        linha digitável</button>
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'pix' && receivable_account.status == 'Pendente'"
                                                        @click="viewPix(receivable_account.id)">Ver
                                                        PIX</button>
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'pix' && receivable_account.status == 'Pendente'"
                                                        @click="copyKeyCopyPaste(receivable_account.payment)">Copiar
                                                        chave Copia e Cola</button>

                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="receivable_accounts.length > 0 && page > 1">
                                        <td colspan="10" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="receivable_accounts.length <= 0">
                                        <td colspan="10" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading},
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: { status: '', method: '' },
            receivable_accounts: [],
            url_api: '',
            page: 1,
            last_page: 1,
            total_itens: 0,
            enable_error_list: false,
            errors: [],
            receivable_account: {
                id: '',
                category_id: '',
                competence_date: '',
                description: '',
                amount: '',
                discount: '',
                fine: '',
                interest: '',
                cod_reference: '',
                due_date: '',
                observation: '',
                interval_recurrence: 'monthly',
                day_generate_receivable: 1,
                repeat: false,
                method: '',
                installment: 1,
                bank_id: '',
                status: '',
                payment_date: '',
                size: '',
                archive: null,
                client_name: '',
                client_document: '',
            }
        }
    },
    computed: {
        
        buttonPagination: function () {
            return this.page > 1;
        },
        badgeStatus() {
            return (status) => {
                if (status == 'Processando') {
                    return 'badge-warning'
                } else if (status == 'Pendente') {
                    return 'badge-info'
                } else if (status == 'Paga') {
                    return 'badge-success'
                } else if (status == 'Cancelada') {
                    return 'badge-danger'
                } else if (status == 'Cancelando') {
                    return 'badge-danger'
                } else if (status == 'chargedback') {
                    return 'badge-danger'
                } else if (status == 'Erro') {
                    return 'badge-danger'
                } else if (status == 'Em atraso') {
                    return 'badge-danger'
                } else if (status == 'Falha') {
                    return 'badge-danger'
                } else if (status == 'Negada') {
                    return 'badge-danger'
                }
                return 'badge-secondary'
            }
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        updateObservation(observation) {
            this.receivable_account.observation = observation;
        },
        bankWithLang({ value }) {
            return value;
        },
        categoryWithLang({ value }) {
            return value;
        },
        handleSelectBank(option) {
            this.receivable_account.bank_id = option.key;

        },
        handleSelectCategory(option) {
            this.receivable_account.category_id = option.key;
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.receivable_accounts = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.receivable_accounts = {}
            this.advanced_search_input = {}
            this.advanced_search_input = { status: '', method: '' },
            this.loadData();
        },

        viewTicketPix(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-ticket-pix/' + id + '/downloadFileTicketPix';
            window.open(url, '_blank');
        },

        viewTicket(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-ticket/' + id + '/downloadFile';
            window.open(url, '_blank');
        },

        copyDigitableLine(payment) {
            window.navigator.clipboard.writeText(payment.data.code);
            this.$notify({
                title: "Sucesso",
                text: "Linha digitável copiada com sucesso!",
                type: 'success'
            });
        },

        viewPix(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-pix/' + id + '/viewPix';
            window.open(url, '_blank');
        },

        copyKeyCopyPaste(payment) {
            window.navigator.clipboard.writeText(payment.data.key);
            this.$notify({
                title: "Sucesso",
                text: "Chave Copia e Cola copiada com sucesso!",
                type: 'success'
            });
        },
        handleFileChange(event) {
            if (event.target.files[0] != undefined) {
                const sizeInBytes = event.target.files[0].size;
                const sizeInMB = sizeInBytes / (1024 * 1024);
                if (sizeInMB > 5) {
                    this.$notify({
                        title: "Informação",
                        text: "Seu arquivo excede o limite de envio. O máximo para envio são 5MB",
                        type: 'info'
                    });
                    this.receivable_account.archive = null;
                } else {
                    this.receivable_account.archive = event.target.files[0];
                }
                this.receivable_account.size = sizeInMB.toFixed(2) + 'MB';

            } else {
                this.receivable_account.size = '';
                this.receivable_account.archive = null;
            }

        },
        async getCategories() {
            this.isLoading = true;
            const response = api.get('/category')
                .then((response) => {
                    this.categories = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        async getBank() {
            this.isLoading = true;
            this.isLoading = true;
            const response = api.get('/bank-account')
                .then((response) => {
                    this.banks = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        methodWithLang({ value }) {
            return value;
        },

        dayGenerateReceivableWithLang({ value }) {
            return value;
        },
        installmentWithLang({ value }) {
            return value;
        },
        intervalRecurrenceWithLang({ value }) {
            return value;
        },

        handleSelectMethod(option) {
            this.receivable_account.method = option.type;
        },
        handleSelectDayGenerateReceivable(option) {
            this.receivable_account.day_generate_receivable = option.type;
        },
        handleSelectInstallment(option) {
            this.receivable_account.total_installment = option.type;

        },
        handleSelectIntervalRecurrence(option) {
            this.receivable_account.interval_recurrence = option.type;
        },

        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/receivable-account-user', {
                params: {
                    'status': this.advanced_search_input.status,
                    'due_date_from': this.advanced_search_input.due_date_from,
                    'due_date_to': this.advanced_search_input.due_date_to,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.receivable_accounts = response.data.data;
                    } else {
                        this.receivable_accounts = this.receivable_accounts.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },


        generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

        downloadFile(receipt_id) {
            this.isLoading = true;
            api.get('/receivable-account/' + receipt_id + '/download', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = 'download_' + this.generateRandom();
                    link.click()
                    URL.revokeObjectURL(link.href);
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        }


    },

    mounted() {
        this.url_api = process.env.VUE_APP_URL_API
        this.loadData();

    },
}
</script>

<style>
/* START TOOLTIP STYLES */
[tooltip] {
    position: relative;
    /* opinion 1 */
}

/* Applies to all tooltips */
[tooltip]::before,
[tooltip]::after {
    text-transform: none;
    /* opinion 2 */
    font-size: .9em;
    /* opinion 3 */
    line-height: 1;
    user-select: none;
    pointer-events: none;
    position: absolute;
    display: none;
    opacity: 0;
}

[tooltip]::before {
    content: '';
    border: 5px solid transparent;
    /* opinion 4 */
    z-index: 1001;
    /* absurdity 1 */
}

[tooltip]::after {
    content: attr(tooltip);
    /* magic! */

    /* most of the rest of this is opinion */
    font-family: Helvetica, sans-serif;
    text-align: center;

    /* 
    Let the content set the size of the tooltips 
    but this will also keep them from being obnoxious
    */
    min-width: 3em;
    max-width: 21em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1ch 1.5ch;
    border-radius: .3ch;
    box-shadow: 0 1em 2em -.5em rgba(0, 0, 0, 0.35);
    background: #333;
    color: #fff;
    z-index: 1000;
    /* absurdity 2 */
}

/* Make the tooltips respond to hover */
[tooltip]:hover::before,
[tooltip]:hover::after {
    display: block;
}

/* don't show empty tooltips */
[tooltip='']::before,
[tooltip='']::after {
    display: none !important;
}

/* FLOW: UP */
[tooltip]:not([flow])::before,
[tooltip][flow^="up"]::before {
    bottom: 100%;
    border-bottom-width: 0;
    border-top-color: #333;
}

[tooltip]:not([flow])::after,
[tooltip][flow^="up"]::after {
    bottom: calc(100% + 5px);
}

[tooltip]:not([flow])::before,
[tooltip]:not([flow])::after,
[tooltip][flow^="up"]::before,
[tooltip][flow^="up"]::after {
    left: 50%;
    transform: translate(-50%, -.5em);
}

/* FLOW: DOWN */
[tooltip][flow^="down"]::before {
    top: 100%;
    border-top-width: 0;
    border-bottom-color: #333;
}

[tooltip][flow^="down"]::after {
    top: calc(100% + 5px);
}

[tooltip][flow^="down"]::before,
[tooltip][flow^="down"]::after {
    left: 50%;
    transform: translate(-50%, .5em);
}

/* FLOW: LEFT */
[tooltip][flow^="left"]::before {
    top: 50%;
    border-right-width: 0;
    border-left-color: #333;
    left: calc(0em - 5px);
    transform: translate(-.5em, -50%);
}

[tooltip][flow^="left"]::after {
    top: 50%;
    right: calc(100% + 5px);
    transform: translate(-.5em, -50%);
}

/* FLOW: RIGHT */
[tooltip][flow^="right"]::before {
    top: 50%;
    border-left-width: 0;
    border-right-color: #333;
    right: calc(0em - 5px);
    transform: translate(.5em, -50%);
}

[tooltip][flow^="right"]::after {
    top: 50%;
    left: calc(100% + 5px);
    transform: translate(.5em, -50%);
}

/* KEYFRAMES */
@keyframes tooltips-vert {
    to {
        opacity: .9;
        transform: translate(-50%, 0);
    }
}

@keyframes tooltips-horz {
    to {
        opacity: .9;
        transform: translate(0, -50%);
    }
}

/* FX All The Things */
[tooltip]:not([flow]):hover::before,
[tooltip]:not([flow]):hover::after,
[tooltip][flow^="up"]:hover::before,
[tooltip][flow^="up"]:hover::after,
[tooltip][flow^="down"]:hover::before,
[tooltip][flow^="down"]:hover::after {
    animation: tooltips-vert 300ms ease-out forwards;
}

[tooltip][flow^="left"]:hover::before,
[tooltip][flow^="left"]:hover::after,
[tooltip][flow^="right"]:hover::before,
[tooltip][flow^="right"]:hover::after {
    animation: tooltips-horz 300ms ease-out forwards;
}

/* UNRELATED to tooltips */
body {
    margin: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: sans-serif;
    background: #ededed;
}

main {
    flex: 1 1 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

aside {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #49b293;
    color: #fff;
    padding: 1em;
}

main div {
    text-align: center;
    color: #353539;
}

main span {
    padding: .5em 1em;
    margin: .5em;
    display: inline-block;
    background: #dedede;
}

aside a {
    color: inherit;
    text-decoration: none;
    font-weight: bold;
    display: inline-block;
    padding: .4em 1em;
}

td,
th,
tr {
    vertical-align: middle;
}
</style>